<template lang="pug">
    //crud-form(
        submit-text='crear comisión'
        v-bind='formProps'
        :fields="fields"
        @reset="resetForm()"
        @submitForm="handleSubmit($event)"
        )
    model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="crear comisión"
        :fields="fields"
        v-model="formData"
        @reset="resetForm"
        @submit="handleSubmit"
        )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelForm } from '@/components/reusable_components/next'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import CommissionService from '@/services/api/commission'
import FieldsCreate from './FieldsShow'
import MdlCommissions from '../../models/Sale/SlCommission'
//
export default {
    name: 'commission-create',
    data: function() {
        return {
            fields: FieldsCreate,
            formData: {},
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        handleSubmit: async function(data) {
            new MdlCommissions(data)
                .save()
                .then(this.handleResponse)
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response) {
            //
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/commissions' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        resetForm() {
            this.formData = {}
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'La comisión fue creada exitosamente.',
                    false,
                    3000
                )
            )
        },
    },
    components: {
        'model-form': ModelForm,
    },
    mounted() {
        //
        this.setTitleTopBar('Crear comisión')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            let pCreate = ctx.$can('CREATE_COMMISSION')
            let pTypeC = ctx.$can('VIEW_ALL_COMMISSION_TYPE')
            if (!(pCreate && pTypeC)) ctx.$router.push('/')
        })
    },
}
</script>
